import { useQuery } from '@tanstack/react-query';

import { Chain } from '~/components/Vendors/Chains/types';

import ReservationService from '~/services/ReservationService';

import { chainQueryKeys } from './useGetChains';

interface ChainResponse {
  status: number;
  result: Chain;
}

export function useGetChainBySfid(sfid?: string | null) {
  return useQuery<Chain>({
    queryKey: chainQueryKeys.bySfid(sfid),
    queryFn: async () => {
      if (!sfid) {
        throw new Error('sfid is required');
      }

      const chainResponse: ChainResponse = await ReservationService.getChainBySfid(sfid);
      return chainResponse.result;
    },
    enabled: !!sfid,
  });
}
